:host {
  display: block;
  padding: 0 var(--_c-card-gap, 24px);
}

.c-card-content {
  display: flex;
  flex-direction: column;
  gap: var(--_c-card-gap);

  ::slotted(*) {
    max-width: 100%;
  }
}
